import { ITrackCreate } from '@tsin-core/models/track-management.model';

const ACTION_SCOPE = '[Tracks]';

export class CreateTracks {
  static readonly type = '[Tracks] Create Tracks';
  constructor(public payload: ITrackCreate) {}
}

export class GetTracks {
  static readonly type = '[Tracks] Get Tracks';
}

export class UpdateTrack {
  static readonly type = '[Tracks] Update Tracks';
  constructor(public editPayload: ITrackCreate) {}
}

export class DeleteTrack {
  static readonly type = `${ACTION_SCOPE} Delete Track`;
  constructor(public id: string) {}
}

export class CreateTrackAction {
  static readonly type = `${ACTION_SCOPE} Create`;
  constructor(public payload: ITrackCreate) {}
}

export class GetTracksAction {
  static readonly type = `${ACTION_SCOPE} Get`;
}

export class UpdateTracksAction {
  static readonly type = `${ACTION_SCOPE} Update`;
}



export class SetLoading {
  static readonly type = `${ACTION_SCOPE} Set Loading`;
  constructor(public loading: boolean) {}
}

export class SetError {
  static readonly type = `${ACTION_SCOPE} Set Error`;
  constructor(public error: string | null) {}
}
